import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

interface StyleProps {
  select: "row" | "none";
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  root: ({ select }) => ({
    cursor: select === "row" ? "pointer" : "auto",
    "&:hover": {
      backgroundColor:
        select === "row" ? theme.palette.gray20.main : "transparent",
    },
  }),
  selectedRow: {
    backgroundColor: theme.palette.gray20.main,
  },
}));

export default useStyles;
